import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum AbsenceTypesEnum {
  Vacation = 'Vacation',
  Absence = 'Absence'
}

marker('Vacation');
marker('Absence');
